/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { VIEW_TYPE_OPTIONS, VIEW_TYPE_LABELS } from '../constants';
import { addUrlParams } from '../utils';
import { SegmentedControl } from './ui';

const ViewTypeTab = ({ onChange, activeValue, disabledValues = [] }) => {
  const [period, setPeriod] = useState(activeValue);

  const handleButtonClick = value => {
    if (disabledValues.includes(value)) return;

    addUrlParams('viewType', value);
    setPeriod(value);
    onChange(value);
  };

  useEffect(() => {
    setPeriod(activeValue);
  }, [activeValue]);

  return (
    <SegmentedControl
      items={Object.entries(VIEW_TYPE_OPTIONS).map(([key, value]) => ({
        value,
        label: VIEW_TYPE_LABELS[key],
        disabled: disabledValues.includes(value)
      }))}
      value={period || VIEW_TYPE_OPTIONS.TOTAL}
      onChange={handleButtonClick}
    />
  );
};

export default ViewTypeTab;
